var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import PageHeader from "@ui/components/header/PageHeader";
import { FInput } from "@ui/components/inputs";
import { PageContainer, PageContent } from "@ui/components/wraper";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { createAlarmCause, updateAlarmCause, getAlarmCauseById, } from "@reducers/alarm-causes/thunk/alarm-causes-thunk";
import { toast } from "@ui/utils/toaster";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
const schema = yup.object().shape({
    definition: yup
        .string()
        .required("Definition is required")
        .min(3, "Definition must be at least 3 characters"),
});
export const AddAlarmCause = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation(["common"]);
    const { selectedAlarmCause, createLoading, updateLoading, singleLoading } = useAppSelector((state) => state.alarmCauses);
    const isEdit = location.pathname.includes("edit");
    const { control, handleSubmit, formState: { errors }, reset, } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            definition: "",
        },
    });
    useEffect(() => {
        if (isEdit && id) {
            dispatch(getAlarmCauseById(id));
        }
    }, [isEdit, id, dispatch]);
    useEffect(() => {
        if (isEdit && selectedAlarmCause) {
            reset({
                definition: selectedAlarmCause.definition,
            });
        }
    }, [isEdit, selectedAlarmCause, reset]);
    const handleFormSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (isEdit && id) {
                yield dispatch(updateAlarmCause({ id, definition: data.definition })).unwrap();
                toast.success(t("common:toasts.alarmCauseUpdatedSuccessfully"));
            }
            else {
                yield dispatch(createAlarmCause({ definition: data.definition })).unwrap();
                toast.success(t("common:toasts.alarmCauseCreatedSuccessfully"));
            }
            navigate("/alarms/manage");
        }
        catch (error) {
            toast.error(error || t("common:toasts.failedToSaveAlarmCause"));
        }
    });
    const actionButton = {
        label: isEdit
            ? t("common:actions.updateAlarmCause")
            : t("common:actions.addAlarmCause"),
        onClick: handleSubmit(handleFormSubmit),
        variant: "contained",
        size: "large",
        loading: createLoading || updateLoading || singleLoading,
    };
    return (React.createElement(PageContainer, null,
        React.createElement(PageHeader, { title: `${isEdit ? t("common:pages.editAlarmCause") : t("common:pages.addAlarmCause")}`, showBackButton: true, bottomActionButton: actionButton }),
        React.createElement(PageContent, { hasBottomAction: true },
            React.createElement(FInput, { control: control, name: "definition", multiline: true, rows: 3, error: errors.definition, label: t("common:labels.definition") }))));
};
